import React from 'react';
import css from './NewListingCard.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';

function decodeHtml(html) {
  var doc = new DOMParser().parseFromString(html, 'text/html');
  var text = doc.documentElement.textContent;
  return new DOMParser().parseFromString(text, 'text/html').documentElement.textContent;
}

function stripHtmlTags(html) {
  return html.replace(/<[^>]*>/g, '');
}

const formatCreatedMonth = isoString => {
  if (!isoString) return null;
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString(undefined, { month: 'short', year: 'numeric' });
};

const STATUS_CONFIG = {
  published: { label: 'Active', tone: 'active' },
  draft: { label: 'Draft', tone: 'draft' },
  closed: { label: 'Closed', tone: 'closed' },
};

export default function NewListingCard(props) {
  const { price, title, imgUrl, dashboardEvents, per, desc, state, categories, createdAt } = props;

  const badgeInfo = STATUS_CONFIG[state] || null;
  const createdLabel = formatCreatedMonth(createdAt);
  const cats = Array.isArray(categories) ? categories : (categories ? [categories] : []);

  return (
    <div className={css.base}>
      <div className={css.image}>
        <img alt={'listing'} src={imgUrl} />
        {badgeInfo && (
          <div className={classNames(css.statusBadge, css[`statusBadge_${badgeInfo.tone}`])}>
            <span className={classNames(css.statusDot, css[`statusDot_${badgeInfo.tone}`])} />
            {badgeInfo.label}
          </div>
        )}
        {(price !== '' && price != null) && (
          <div className={css.price}>
            ${price?.toLocaleString()}{per && ` / ${per.charAt(0)}`}
          </div>
        )}
      </div>

      <div className={css.content}>
        <div className={css.title}>{title}</div>
        <div className={css.description}>{stripHtmlTags(decodeHtml(desc))}</div>
        {cats.length > 0 && (
          <div className={css.tagList}>
            {cats.map((c, i) => (
              <span key={i} className={css.tag}>{c}</span>
            ))}
          </div>
        )}
        {createdLabel && (
          <div className={css.meta}>
            <span className={css.metaItem}>
              <FontAwesomeIcon icon={faCalendarAlt} className={css.metaIcon} />
              Created {createdLabel}
            </span>
          </div>
        )}
      </div>

      <div className={css.line} />
      <div className={css.actions}>
        <div>
          {dashboardEvents
            ?.filter(x => !!x.isLeft)
            ?.map((item, idx) => (
              <div
                key={`l-${idx}`}
                onClick={item.onClick}
                className={css.actionPrimary}
              >
                <FontAwesomeIcon icon={item.icon} /> {item.name}
              </div>
            ))}
        </div>

        <div>
          {dashboardEvents
            ?.filter(x => !x.isLeft)
            ?.map((item, idx) => {
              const isIconOnly = !!item.iconOnly;
              return (
                <div
                  key={`r-${idx}`}
                  onClick={item.onClick}
                  className={isIconOnly ? css.actionIconOnly : css.actionPrimary}
                  title={isIconOnly ? item.name : undefined}
                >
                  <FontAwesomeIcon icon={item.icon} /> {!isIconOnly && item.name}
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}
